module.exports = __webpack_public_path__ + "img/sdg14_id.355cf9e1.svg";